import React from "react";
import classNames from "classnames";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  extraIconClasses?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isMenuCollapsed: boolean;
}

const Hamburger: React.FC<Props> = ({ extraIconClasses, onClick, isMenuCollapsed=true, ...rest }: Props): JSX.Element => {

  const icon = classNames(
    "caprx-icon-menutoggleleft",
    extraIconClasses,
    { "open": !isMenuCollapsed },
  );

  return (
    <button onClick={onClick} className="caprx-hamburger" {...rest}>
      <i className={icon} aria-hidden="true" />
    </button>
  );
};

export default Hamburger;
